import { memo } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import {
  IconColumn02,
  IconColumn03,
} from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  /** className */
  className?: string;
  /** 현재 노출 중인 열 수 (2 | 3) */
  perView?: 2 | 3;
  /** 클릭 시 전환될 다음 열 수를 전달 */
  onClick?: (perView: 2 | 3) => void;
}

const ColumnToggle = ({ className, perView = 2, onClick }: IProps) => {
  const next: 2 | 3 = perView === 2 ? 3 : 2;
  const cName = classNameBind([
    'column-toggle',
    `per-view-${perView}`,
    className || '',
  ]);

  return (
    <S.ColumnToggle
      className={cName}
      label={`${next}열로 보기`}
      icon={perView === 2 ? <IconColumn02 /> : <IconColumn03 />}
      onClick={() => onClick?.(next)}
    />
  );
};

export default memo(ColumnToggle);
